import React from "react";
import toaster from "../utils/toaster";
const main_url = process.env.REACT_APP_API_URL;
const core_url = process.env.REACT_APP_CORE_URL;

let firebaseToken = "";

export function setFirebaseToken(token) {
  firebaseToken = token;
}

function getFirebaseToken() {
  return firebaseToken.length === 0
    ? localStorage.getItem("FBTOKEN")
    : firebaseToken;
}

const getHeaders = (headers, content = "application/json") => {
  let initial = {
    "Content-Type": content,
    Accept: "application/json",
    Authorization: "Bearer " + localStorage.getItem("token"),
    registrationId:
      localStorage.getItem("FCMID") === null ||
      localStorage.getItem("FCMID") === "null"
        ? getFirebaseToken()
        : localStorage.getItem("FCMID"),
  };
  let withOutContentType = {
    Accept: "application/json",
    Authorization: "Bearer " + localStorage.getItem("token"),
  };
  if (content !== null) return { ...initial, headers };
  else return { ...withOutContentType, headers };
};
const notify_server_error = () => toaster.error("مشکلی برای سرور رخ داده است.");
const notify_error_messages = (messages) => {
  const component = () => {
    let array = Object.values(messages);
    return (
      <div style={{ direction: "rtl", fontFamily: "IRANSans" }}>
        <ul>
          {array.map((item) => {
            return item.map((message, index) => {
              return <li key={index}>{message}</li>;
            });
          })}
        </ul>
      </div>
    );
  };
  toaster.error(component);
};
const Http = {
  main_url: main_url,
  GET: (uri, headers, dispatch, error_function) => {
    let get = fetch(main_url + uri, {
      method: "GET",
      headers: getHeaders(headers),
    });
    return get.then((response) => {
      if (response.status !== 200) {
        Http.HANDLE_ERRORS(response);
        dispatch(error_function(response));
      } else return response.json();
    });
  },
  POST: (uri, payload, headers, dispatch, error_function) => {
    let post = fetch(main_url + uri, {
      method: "POST",
      body: JSON.stringify(payload),
      headers: getHeaders(headers),
    });
    return post.then((response) => {
      if (response.status !== 200) {
        Http.HANDLE_ERRORS(response);
        dispatch(error_function(response));
      } else return response.json();
    });
  },
  PATCH: (uri, payload, headers, dispatch, error_function) => {
    let post = fetch(main_url + uri, {
      method: "PATCH",
      body: JSON.stringify(payload),
      headers: getHeaders(headers),
    });
    return post.then((response) => {
      if (response.status !== 200) {
        Http.HANDLE_ERRORS(response);
        dispatch(error_function(response));
      } else return response.json();
    });
  },
  PUT: (uri, payload, headers, dispatch, error_function) => {
    let post = fetch(main_url + uri, {
      method: "PUT",
      body: JSON.stringify(payload),
      headers: getHeaders(headers),
    });
    return post.then((response) => {
      if (response.status !== 200) {
        Http.HANDLE_ERRORS(response);
        dispatch(error_function(response));
      } else return response.json();
    });
  },
  DELETE: (uri, payload, headers, dispatch, error_function) => {
    let post = fetch(main_url + uri, {
      method: "DELETE",
      body: JSON.stringify(payload),
      headers: getHeaders(headers),
    });
    return post.then((response) => {
      if (response.status !== 200) {
        Http.HANDLE_ERRORS(response);
        dispatch(error_function(response));
      } else return response.json();
    });
  },
  POST_FORM: (uri, payload, headers, dispatch, error_function) => {
    let formData = new FormData();
    Object.keys(payload).forEach((item) => {
      formData.set(item, payload[item]);
    });
    let post = fetch(main_url + uri, {
      method: "POST",
      body: formData,
      headers: getHeaders(headers, null),
    });
    return post.then((response) => {
      if (response.status !== 200) {
        Http.HANDLE_ERRORS(response);
        dispatch(error_function(response));
      } else return response.json();
    });
  },
  POST_FORM_CORE: (uri, payload, headers, dispatch, error_function) => {
    let formData = new FormData();
    Object.keys(payload).forEach((item) => {
      formData.set(item, payload[item]);
    });
    let post = fetch(core_url + uri, {
      method: "POST",
      body: formData,
      headers: getHeaders(headers, null),
    });
    return post.then((response) => {
      if (response.status !== 200) {
        Http.HANDLE_ERRORS(response);
        dispatch(error_function(response));
      } else return response.json();
    });
  },
  HANDLE_ERRORS: (response) => {
    if (response.status === 401) {
      localStorage.removeItem("token");
      window.location.reload();
    } else if (response.status === 500) {
      notify_server_error();
    } else {
      response
        .json()
        .then((json_response) => {
          if (json_response.result && json_response.result === "ERROR") {
            notify_error_messages(json_response.messages);
          } else {
            notify_server_error();
          }
        })
        .catch((error) => {
          toaster.error(error.toString);
        });
    }
  },
};
export default Http;
